module.exports = __webpack_public_path__ + "image/VP_2.png";